<template>
  <van-dialog
    v-model="updateAppDialog"
    :showConfirmButton="false"
  >
    <div class="dialogBox">
      <h2 class="title">
        发现新版本：<span>{{appVersionCode}}</span>
      </h2>
      <div class="updateList">
        <div class="updateListCell">
          <van-tag
            plain
            type="danger"
            size="large"
          >new</van-tag>
          <span>{{description}}</span>
        </div>
        <p
          id="copy"
          style="display:none;"
        >{{downloadUrl}}</p>
      </div>
      <div class="updateBtn">
        <van-button
          plain
          size="normal"
          @click="clickUpdate"
          type="info"
        >立即更新</van-button>
      </div>
      <div
        class="closeBtn"
        v-if="forceUpdate !== '1'"
      >
        <van-icon
          name="close"
          @click="closeDialog"
        />
      </div>
    </div>
  </van-dialog>
</template>

<script>
import $ from 'jquery'
export default {
  methods: {
    clickUpdate () {
      if (this.$terminal === 'IOS') {
        this.$toast('请去Appstore中更新')
        if (this.forceUpdate !== '1') {
          this.closeDialog()
        }
      } else {
        window.jdJsCallNative.callNativeBrowser('https://m-due-diligence.jd.com/static/download.html')
      }
    },
    closeDialog () {
      this.$store.commit('global/SET_UPDATEAOODIALOG', false)
      this.$router.push(this.returnUrl || '/mine')
    }
  },
  computed: {
    updateAppDialog: {
      get () {
        return this.$store.state.global.updateAppDialog
      },
      set (val) {
        this.$store.commit('global/SET_UPDATEAOODIALOG', val)
      }
    }
  },
  props: {
    appVersionCode: {
      // required: true,
      type: String
    },
    downloadUrl: {
      type: String
    },
    description: {
      type: String
    },
    forceUpdate: {
      type: String
    },
    returnUrl: {
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.van-dialog {
  overflow: visible;
}
.dialogBox {
  padding: 20px 15px;
  position: relative;
  .title {
    text-align: center;
    font-size: 24px;
    height: 34px;
    line-height: 34px;
  }
  .updateList {
    margin: 20px 0;
    .updateListCell {
      line-height: 30px;
    }
  }
  .updateBtn {
    text-align: center;
    button {
      border: 1px solid #1989fa;
    }
  }
  .closeBtn {
    position: absolute;
    bottom: -50px;
    left: 142px;
    font-size: 36px;
    color: #1989fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/updateAppDialog.vue